import { combineReducers, createStore } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import {
  testeReducers,
  sidebarReducer,
  themeReducer,
  customizerReducer,
  rtlReducer,
  authReducer,
  usersReducer
} from '../../redux/reducers/index';

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  rtl: rtlReducer,
  sidebar: sidebarReducer,
  testeeeReducers: testeReducers,
  customizer: customizerReducer,
  user: authReducer,
  users: usersReducer
});
const store = createStore(reducer);

export default store;
